import { render } from "./ProductsList.vue?vue&type=template&id=74f4d574&scoped=true"
import script from "./ProductsList.vue?vue&type=script&lang=js"
export * from "./ProductsList.vue?vue&type=script&lang=js"

import "./ProductsList.vue?vue&type=style&index=0&id=74f4d574&scoped=true&lang=css"

import exportComponent from "C:\\Users\\User\\Downloads\\ASKNC-Website\\asknc-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f4d574"]])

export default __exports__